import { render, staticRenderFns } from "./HomeRequirement.vue?vue&type=template&id=54e21b22&scoped=true"
import script from "./HomeRequirement.vue?vue&type=script&lang=js"
export * from "./HomeRequirement.vue?vue&type=script&lang=js"
import style0 from "./HomeRequirement.vue?vue&type=style&index=0&id=54e21b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e21b22",
  null
  
)

export default component.exports